<template>
  <el-popover
    placement="left"
    width="600"
    trigger="click"
    :visible-arrow="false"
    @show="showPopover"
    @hide="isActive = false"
    popper-class="pagoda-feedback-popover"
  >
    <div class="pagoda-feedback-content">
      <div class="header">
        <div class="header-title">猴果果智能客服</div>
        <div class="header-desc">协助您高效解决问题</div>
      </div>
      <div
        class="content"
        ref="chatContent"
      >
        <div
          class="welcome"
          v-if="!!welcomeData"
        >
          <div v-html="welcomeData.textLink"></div>
          <div
            class="welcome-feedback"
            v-html="welcomeData.feedback"
            @click="selectFeedback"
          ></div>
        </div>
        <div
          class="history-btn"
          @click="getHistory"
          v-if="loadHistory && !!user && !!user.oaid"
        >查看历史消息</div>
        <div class="chat-list">
          <chat-bubble
            v-for="(message, index) in messageList"
            :key="`message-item-${index}`"
            :chatData="message"
            @selectFeedback="selectFeedback"
            @selectFeedbackTypes="selectFeedbackTypes"
          ></chat-bubble>
        </div>
      </div>
      <div class="footer">
        <el-input
          type="textarea"
          :rows="4"
          v-model="inputStr"
          @keyup.enter.native="handleEnterPress"
          placeholder="请描述你的问题，例如：现价单录入"
          maxlength="300"
          show-word-limit
        ></el-input>
        <div class="operate">
          <el-upload
            class="upload-demo"
            ref="upload"
            :disabled="uploadDisabled()"
            title="反馈时可上传"
            :action="imgServerUpload"
            :before-upload="beforeImgUpload"
            :on-success="uploadSuccess"
            :show-file-list="false"
          >
            <img
              class="default-image"
              :class="{ 'disabled-upload': uploadDisabled() }"
              :src="defaultImage"
              slot="trigger"
              v-if="!imageUrl"
            />
            <div
              v-else
              class="upload-img"
            >
              <img :src="imageUrl" />
              <i
                class="el-icon-error"
                @click.stop="closeImage"
              ></i>
            </div>
          </el-upload>
          <div class="send-box">
            <el-checkbox
              v-model="anonymousSubmit"
              v-if="!!user && !!user.oaid"
            >匿名提交</el-checkbox>
            <el-button
              :disabled="sendBtnDisabled()"
              type="primary"
              @click="sendMessage"
              :plain="false"
            >发送</el-button>
          </div>
        </div>
      </div>
    </div>
    <div
      slot="reference"
      class="pagoda-feedback-active"
      :class="{
        'is-active': isActive
      }"
    >
      <i class="pd-icon-customer-service" />
      <span class="title">智能</span>
      <span class="title">助手</span>
    </div>
  </el-popover>
</template>

<script>
import ChatBubble from './component/chat-bubble.vue'
import Communication from './communication'
import axios from 'axios'
import { Message } from 'element-ui'
import defaultImage from './images/default_image@2x.png'
import magic from './images/magic@2x.png'
import { isEmpty } from '../../../utils'

export default {
  name: 'Feedback',
  components: {
    ChatBubble
  },
  props: {
    user: {
      type: Object,
      default: () => {
        return {
          oaid: '',
          username: '',
          phone: '',
          post: ''
        }
      }
    },
    projectCode: {
      type: String,
      required: true
    },
    env: {
      type: String,
      default: 'dev'
    }
  },
  computed: {
    appServer() {
      switch (this.env) {
        case 'dev':
          return '//pfb.kd1.pagoda.com.cn'
        case 'test':
          return '//pfb.kt3.pagoda.com.cn'
        case 'uat':
          return '//pfb.ks1.pagoda.com.cn'
        case 'prod':
          return '//pfb.pagoda.com.cn'
        default:
          return '//pfb.kd1.pagoda.com.cn'
      }
    }
  },
  watch: {
    messageList() {
      this.$nextTick(() => {
        this.$refs.chatContent.scrollTop = this.$refs.chatContent.scrollHeight
      })
    },
    user() {
      this.anonymousSubmit = !(!!this.user && !!this.user.oaid)
      this.communication.updateUser(this.user)
    }
  },
  data() {
    return {
      isActive: false,
      communication: null,
      welcomeData: null,
      inputStr: '',
      messageList: [],
      imgServerUpload: 'http://193.112.247.196/miResourceMgr/upload',
      loadHistory: true,
      imageUrl: '',
      anonymousSubmit: false,
      defaultImage: defaultImage,
      magicImage: magic
    }
  },
  mounted() {
    this.initParams()
  },
  methods: {
    initParams() {
      this.anonymousSubmit = !(!!this.user && !!this.user.oaid)
      this.communication = new Communication(this.appServer, this.env)
      this.communication.init({
        user: this.user,
        projectCode: this.projectCode,
        messageList: this.messageList
      })
    },
    showPopover() {
      this.isActive = true

      axios
        .get(`${this.appServer}/chat/welcome/${this.projectCode}`)
        .then(res => {
          if (!res.data || !res.data.success) throw new Error()
          const data = res.data.data
          const {
            feedback,
            welcome: { text, link }
          } = data
          this.welcomeData = {
            textLink: text
              .replace(/%link%/, `<a target="_blank" href=${link}>`)
              .replace(/%\/link%/, '</a>'),
            feedback: feedback
              .replace(/%action%/, '<span class="system-feedback">')
              .replace(/%\/action%/, '</span>')
          }
        })
        .catch(err => {
          Message.error((err.data && err.data.message) || '获取欢迎语句错误, 检查projectCode')
          console.error(err)
        })
    },
    selectFeedback(event) {
      if (event.target.nodeName.toLowerCase() === 'span') {
        this.communication.startFeedback()
      }
    },
    handleEnterPress() {
      this.inputStr = (this.inputStr || '').slice(0, -1)
      this.sendMessage()
    },
    sendBtnDisabled() {
      return !this.inputStr && !(!this.uploadDisabled() && !!this.imageUrl)
    },
    sendMessage() {
      if (this.sendBtnDisabled()) return
      const stage = this.communication.message.stage || 1
      switch (stage) {
        case 3: // 收集系统反馈
          this.sendFeedback()
          break
        case 2: // 选择反馈类型
          this.selectFeedbackTypes(this.inputStr)
          break
        default:
          this.communication.search(this.inputStr)
      }
      this.inputStr = ''
      this.closeImage()
    },
    selectFeedbackTypes(type) {
      const availableTypes = this.communication.message.availableTypes
      const findItem = availableTypes.find(item => item.name === type)
      if (findItem) {
        this.communication.selectType(findItem)
      } else {
        // 输入无匹配反馈类型，则按照其他类型直接反馈内容
        this.communication.message.feedbackType = availableTypes[availableTypes.length - 1].code
        this.sendFeedback()
      }
    },
    sendFeedback() {
      this.communication.sendFeedback(
        {
          text: this.inputStr,
          images: this.imageUrl ? [this.imageUrl] : null
        },
        this.anonymousSubmit
      )
    },
    getHistory() {
      this.communication.getHistory(() => {
        this.loadHistory = false
        if (isEmpty(this.messageList)) {
          this.$message({
            message: '暂无历史消息',
            type: 'warning'
          })
        }
      })
    },
    beforeImgUpload(file) {
      const allowList = ['jpeg', 'png', 'bmp']
      if (!allowList.map(item => `image/${item}`).includes(file.type)) {
        this.$message.error(`上传图片只能为jpg,${allowList.join(',')}等格式！`)
        return false
      }
      if (!(file.size / 1024 / 1024 < 4)) {
        this.$message.error('上传头像图片大小不能超过4MB!')
        return false
      }
      return true
    },
    uploadSuccess(res, file) {
      const { errorCode, description } = res
      if (errorCode === 0) {
        const { httpUrl, filePath } = res.data
        this.imageUrl = `${httpUrl}${filePath}`
      } else {
        this.$message.error(description)
      }
    },
    closeImage() {
      this.imageUrl = ''
    },
    uploadDisabled() {
      // 只有进行反馈时才可以选择图片
      return !(!!this.communication && this.communication.message.stage === 3)
    }
  }
}
</script>
